import type {Collections} from 'lib/db/collections'

import ClientCollection from './swr-collection'

/**
 * Create a ClientCollection instance with the type inferred from the collection name.
 */
function createClientCollection<K extends keyof Collections>(name: K) {
  return new ClientCollection<Collections[K]>(name)
}

export {ClientCollection, createClientCollection}
